import { useLocation, Outlet } from 'react-router-dom';
import { useState } from 'react';
import { Box, Container, Typography, Stack, Link } from '@mui/material';
import Logo from '../../components/Logo';
import MainFooterCPO from './MainFooterCPO';
import MainHeaderCPO from './MainHeaderCPO';
import DiscretionaryDonationFAB from './DiscretionaryDonationFAB';
import DiscretionaryModal from './modals/DiscretionaryModal';
import BasketModal from './modals/BasketModal';
import GiftCardModal from './modals/GiftCardModal';
import SimplifiedGivingBasketModal from './modals/simplified_giving_basket/SimplifiedGivingBasket';
import ValidateVoucherModal from './modals/voucher_modals/ValidateVoucherModal';
import SupportButton from '../../components/SupportButton';

export default function MainLayout() {
  const { pathname } = useLocation();

  const isHome = pathname === '/';
  const hideFooterOnPages = ['/resultpage', '/explore-project'];
  const shouldHideFooter = hideFooterOnPages.some((path) => pathname.startsWith(path));

  const [showDiscretioanry, setShowDiscretionary] = useState(false);
  const [showBasket, setShowBasket] = useState(false);

  return (
    <Stack sx={{ minHeight: 1 }}>
      <MainHeaderCPO setShowDiscretionary={setShowDiscretionary} />

      <Outlet />

      <Box sx={{ flexGrow: 1 }} />

      {!shouldHideFooter && <MainFooterCPO />}

      <DiscretionaryModal open={showDiscretioanry} onClose={() => setShowDiscretionary(false)} />

      <SimplifiedGivingBasketModal />

      <GiftCardModal />

      <ValidateVoucherModal />

      {/* <SupportButton /> */}
    </Stack>
  );
}
